var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcProfileCoupon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#E7EDFF",
    cx: 15,
    cy: 15,
    r: 15
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#67F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.364 21.32c-3.208 0-4.182-.968-4.182-4.153v-.361c0-.297.247-.542.545-.542C8.425 16.264 9 15.694 9 15c0-.693-.575-1.264-1.273-1.264a.548.548 0 0 1-.545-.542v-.36c0-3.186.974-4.153 4.182-4.153h7.272c3.208 0 4.182.967 4.182 4.152v.723a.548.548 0 0 1-.545.541c-.698 0-1.273.57-1.273 1.264 0 .693.575 1.264 1.273 1.264.298 0 .545.246.545.542 0 3.185-.974 4.152-4.182 4.152h-7.272zm0-1.084h7.272c2.43 0 3.019-.426 3.084-2.593a2.35 2.35 0 0 1-1.81-2.282c0-1.105.777-2.037 1.817-2.282v-.246c0-2.578-.487-3.07-3.09-3.07h-7.273c-2.56 0-3.077.47-3.091 2.955A2.357 2.357 0 0 1 10.09 15a2.357 2.357 0 0 1-1.818 2.282c.014 2.485.53 2.954 3.09 2.954z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 11.028V9.222c0-.296.247-.541.545-.541.299 0 .546.245.546.541v1.806a.548.548 0 0 1-.546.541.548.548 0 0 1-.545-.541zM13 16.322v-2.65c0-.297.247-.542.545-.542.299 0 .546.245.546.541v2.65a.543.543 0 0 1-.546.542.548.548 0 0 1-.545-.541zM13 20.778v-1.806c0-.296.247-.541.545-.541.299 0 .546.245.546.541v1.806a.548.548 0 0 1-.546.541.548.548 0 0 1-.545-.541z",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcProfileCoupon);
export default __webpack_public_path__ + "static/media/ic_profile_coupon.6d6e2e07801bc589a24d610289d4e805.svg";
export { ForwardRef as ReactComponent };